<script>
  import { router, page } from '@inertiajs/svelte'

  // tabs: [{ key, label, count?, disabled?, tooltip? }]
  // `onselect` takes over from the default server visit, for tabs that filter
  // data already on the page (the caller still keeps the choice in the URL).
  let { tabs = [], param = 'tab', active = tabs[0]?.key, onselect = null } = $props()

  const select = (key) => {
    if (onselect) return onselect(key)

    const url = new URL($page.url, 'http://placeholder')
    url.searchParams.set(param, key)
    url.searchParams.delete('page')
    router.get(`${url.pathname}${url.search}`, {}, { preserveState: true, preserveScroll: true })
  }
</script>

<div role="tablist" class="tabs tabs-lift">
  {#each tabs as tab (tab.key)}
    <button
      type="button"
      role="tab"
      class="tab"
      class:tab-active={tab.key === active}
      class:tab-disabled={tab.disabled}
      disabled={tab.disabled}
      title={tab.tooltip}
      onclick={() => tab.disabled || select(tab.key)}
    >
      {tab.label}
      {#if tab.count !== undefined}<span class="badge badge-sm ml-2">{tab.count}</span>{/if}
    </button>
  {/each}
</div>
